var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-card",
    { staticClass: "bg-grey-1" },
    [
      _c(
        "q-card-main",
        {
          staticClass: "relative-position",
          class: _vm.webcastBlocked ? "no-pointer-events" : "cursor-pointer"
        },
        [
          _c("div", { staticClass: "line-card bg-primary absolute-top" }),
          _c("div", { staticClass: "row q-my-sm" }, [
            _c(
              "div",
              {
                staticClass: "col-3",
                class: _vm.webcastBlocked ? "disable-image" : "",
                on: {
                  click: function($event) {
                    return _vm.goToWebcast()
                  }
                }
              },
              [
                _vm.webcast.image_small
                  ? _c("img", {
                      staticClass: "training-thumb",
                      attrs: { src: _vm.webcast.image_small }
                    })
                  : _vm._e(),
                !_vm.webcast.image_small
                  ? _c("img", {
                      staticClass: "training-thumb",
                      attrs: { src: _vm.getPlaceholder }
                    })
                  : _vm._e()
              ]
            ),
            _c(
              "div",
              {
                staticClass: "col-9",
                on: {
                  click: function($event) {
                    return _vm.goToWebcast()
                  }
                }
              },
              [
                _c("div", { staticClass: "row" }, [
                  _c(
                    "div",
                    {
                      staticClass: "col-12 q-title text-weight-medium",
                      class: _vm.webcastBlocked ? "text-faded" : "text-primary"
                    },
                    [
                      _vm._v(
                        "\n                        " +
                          _vm._s(_vm.webcast.title) +
                          "\n                    "
                      )
                    ]
                  ),
                  _c(
                    "div",
                    {
                      staticClass: "col-12 q-subheading text-weight-regular",
                      class: _vm.webcastBlocked ? "text-faded" : "text-primary"
                    },
                    [
                      _vm._v(
                        "\n                        " +
                          _vm._s(_vm.$t("transmission_date")) +
                          " " +
                          _vm._s(_vm.fDate(_vm.webcast.transmission_date)) +
                          " " +
                          _vm._s("(" + _vm.webcast.timezone + ")") +
                          "\n                    "
                      )
                    ]
                  ),
                  _c("div", { staticClass: "col-12 q-mt-md" }, [
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col-6" }, [
                        _vm.webcast.areas.length > 0
                          ? _c("p", { staticClass: "caption" }, [
                              _vm._v(
                                "\n                                    " +
                                  _vm._s(_vm.$t("areas")) +
                                  "\n                                "
                              )
                            ])
                          : _vm._e(),
                        _vm.webcast.areas.length > 0
                          ? _c(
                              "p",
                              { staticClass: "tooltip q-mb-sm" },
                              _vm._l(_vm.webcast.areas, function(area, index) {
                                return _c("span", { key: index }, [
                                  _vm._v(
                                    "\n                                        " +
                                      _vm._s(_vm.getArea(area))
                                  ),
                                  _vm.webcast.areas.length - 1 > index
                                    ? _c("span", [_vm._v(", ")])
                                    : _vm._e()
                                ])
                              }),
                              0
                            )
                          : _vm._e(),
                        _vm.webcast.user_groups.length > 0
                          ? _c("p", { staticClass: "caption" }, [
                              _vm._v(
                                "\n                                    " +
                                  _vm._s(_vm.$t("groups")) +
                                  "\n                                "
                              )
                            ])
                          : _vm._e(),
                        _vm.webcast.user_groups.length > 0
                          ? _c(
                              "p",
                              { staticClass: "tooltip q-mb-sm" },
                              _vm._l(_vm.webcast.user_groups, function(
                                group,
                                index
                              ) {
                                return _c("span", { key: index }, [
                                  _vm._v(
                                    "\n                                        " +
                                      _vm._s(_vm.getGroup(group))
                                  ),
                                  _vm.webcast.user_groups.length - 1 > index
                                    ? _c("span", [_vm._v(", ")])
                                    : _vm._e()
                                ])
                              }),
                              0
                            )
                          : _vm._e()
                      ]),
                      _c("div", { staticClass: "col-6" }, [
                        _vm.webcast.tags.length > 0
                          ? _c("p", { staticClass: "caption" }, [
                              _vm._v(
                                "\n                                    " +
                                  _vm._s(_vm.$t("tags")) +
                                  "\n                                "
                              )
                            ])
                          : _vm._e(),
                        _c(
                          "p",
                          { staticClass: "tooltip q-mb-sm" },
                          _vm._l(_vm.webcast.tags, function(tag, index) {
                            return _c("span", { key: index }, [
                              _vm._v(
                                "\n                                        " +
                                  _vm._s(_vm.getTag(tag))
                              ),
                              _vm.webcast.tags.length - 1 > index
                                ? _c("span", [_vm._v(", ")])
                                : _vm._e()
                            ])
                          }),
                          0
                        )
                      ])
                    ])
                  ])
                ])
              ]
            )
          ])
        ]
      ),
      _vm.showSubscribeButton ? _c("q-card-separator") : _vm._e(),
      _vm.showSubscribeButton
        ? _c(
            "q-card-actions",
            [
              _c("q-btn", {
                staticClass: "full-width",
                attrs: {
                  color: _vm.getSubscribeButtonColor,
                  label: _vm.$t(_vm.getSubscribeButtonLabel),
                  icon: _vm.getSubscribeButtonIcon
                },
                on: {
                  click: function($event) {
                    return _vm.subscribeWebcast()
                  }
                }
              })
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }